import { Select } from '@/common/interfaces';
import { UserInfo } from '@/pages/Registration/Registration.interfaces';
import {
  DocumentTemplate,
  Question,
  VirtualAsset,
} from '@/store/api/types.api';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface IInitialState {
  userInfo: UserInfo | null;
  countries: Select[];
  documents: DocumentTemplate[];
  templates: Select[];
  currency: Select[];
  requiredDocSelect: Select[];
  tests: Question[];
  virtualAssets: Select[];
}

const initialState: IInitialState = {
  userInfo: null,
  countries: [],
  documents: [],
  templates: [],
  currency: [],
  requiredDocSelect: [],
  tests: [],
  virtualAssets: [],
};

const registrationSlice = createSlice({
  name: 'registration',
  initialState,
  reducers: {
    setUserInfo: (state, action: PayloadAction<UserInfo>) => {
      state.userInfo = action.payload;
    },

    setCountries: (state, action: PayloadAction<Select[]>) => {
      state.countries = action.payload;
    },

    setDocuments: (state, action: PayloadAction<DocumentTemplate[]>) => {
      state.documents = action.payload;
    },

    setTemplates: (state, action: PayloadAction<Select[]>) => {
      state.templates = action.payload;
    },

    setRequiredDocSelect: (state, action: PayloadAction<Select[]>) => {
      state.requiredDocSelect = action.payload;
    },

    setTests: (state, action: PayloadAction<Question[]>) => {
      state.tests = action.payload;
    },

    setVirtualAssets: (state, action: PayloadAction<Select[]>) => {
      state.virtualAssets = action.payload;
    },

    setCurrency: (state, action: PayloadAction<Select[]>) => {
      state.currency = action.payload;
    },
  },
});

export const {
  setCountries,
  setDocuments,
  setTemplates,
  setUserInfo,
  setRequiredDocSelect,
  setTests,
  setVirtualAssets,
  setCurrency,
} = registrationSlice.actions;

export default registrationSlice.reducer;
